const r=["cssVars","componentsConfig","inputs","errorText","errorType","clientScripts"];export{r as EXCLUDED_STATE_KEYS};
//# sourceMappingURL=customScreens.js.map
